import React, { useContext } from "react"
import makeStyles from "../muiStylesCompat"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import { ImpersonateContext } from "../context/impersonate"

const useStyles = makeStyles((theme) => ({
    container: {
        position: "fixed",
        top: theme.spacing(1),
        right: theme.spacing(2),
        zIndex: theme.zIndex.snackbar,
        pointerEvents: "none",
    },
    banner: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        padding: theme.spacing(1, 2),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "#FAE8C8",
        color: "#663C00",
        boxShadow: theme.shadows[2],
        pointerEvents: "auto",
    },
    email: {
        fontWeight: 600,
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
    },
}))

export function ImpersonationBanner() {
    const classes = useStyles()
    const { asEmail, exitImpersonation } = useContext(ImpersonateContext)

    if (!asEmail) {
        return null
    }

    return (
        <div className={classes.container}>
            <div className={classes.banner}>
                <Typography variant="body2">
                    Acting as <span className={classes.email}>{asEmail}</span>
                </Typography>
                <Button
                    size="small"
                    variant="contained"
                    onClick={exitImpersonation}
                >
                    Exit
                </Button>
            </div>
        </div>
    )
}
